import { render, staticRenderFns } from "./settingCompany.vue?vue&type=template&id=748d4d8b&scoped=true&"
import script from "./settingCompany.vue?vue&type=script&lang=js&"
export * from "./settingCompany.vue?vue&type=script&lang=js&"
import style0 from "./settingCompany.vue?vue&type=style&index=0&id=748d4d8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d4d8b",
  null
  
)

export default component.exports